import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import noop from 'lodash/noop';

const BUTTONS = [
  { text: "I've got a question about training" },
  { text: "I need help using the app" },
  { text: "I've got a subscription or account question" },
  { text: "Something else", hideMenu: true },
];

export default function ChatButtons(props) {

  const {
    sendMessage = noop,
    onHide = noop,
  } = props;

  const [ show, setShow ] = useState(true);

  function handleClick(item) {
    if (item.hideMenu) {
      setShow(false);
      onHide();
    } else {
      sendMessage(item.text);
      setShow(false);
      onHide();
    }
  }

  if (!show) return null;

  return (
    <div className="d-flex flex-wrap justify-content-center" style={{ gap: '8px', padding: '8px 16px' }}>
      {BUTTONS.map((item) => {
        return (
          <Button key={item.text} variant="outline-primary" className="chat-button"
            onClick={() => handleClick(item)}>
            {item.text}
          </Button>
        );
      })}
    </div>
  );
}